// Testing the same logging for both node and browser
// TODO test more and make default
import pino from 'pino';
import { gcpLogOptions } from './gcpLoggerConfig.js';

const isoTime = () => `,"time":"${new Date().toISOString()}"`;

const getOpts = () => {
  try {
    if (process) {
      return gcpLogOptions({
        level: process?.env?.LOG_LEVEL || 'debug',
        timestamp: isoTime,
      });
    } else {
      return {};
    }
  } catch (e) {
    return {};
  }
};

const logger = pino(getOpts());

export const getLogger = (mod = null, props = null, prefix = null) => {
  if (!mod) {
    return logger;
  }
  let bindings = { mod: mod };
  let options = undefined;
  if (props) {
    bindings = Object.assign(bindings, props);
  }
  if (prefix) {
    options = { msgPrefix: prefix };
  }
  return logger.child(bindings, options);
};
